import {BUTTON_COLOR, BUTTON_STYLE} from '../../../constants';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import GenericModal from '../../modal/generic_modal';
import {SignUpError, SignUpModalStyle} from './signup_modal_styled';
import {PlanSection} from './plan_section';
import DetailsSection, {EU_COUNTRIES_CODES} from './details_section';
import Receipt from './receipt';
import Util from '../../../forecast-app/shared/util/util';
import updateCompanyInternalDataMutation from '../../../mutations/mission_control/update_company_internal_data_mutation';
import ValidateCouponMutation from '../../../mutations/validate_coupon_mutation';
import TrialEndCreateCustomerInternalMutation from '../../../mutations/mission_control/trial_end_create_customer_internal_mutation';

class SignUpModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			billing: 'annual',
			term: '1 Year',
			selectedTier: 'PRO',
			currency: 'USD',
			isOnboarding: false,
			seats: Math.max(props.company.minimumSeats || 0, props.company.users),
			virtualSeats: Math.max(props.company.minimumVirtualSeats || 0, props.company.virtualUsers),
			step: 'PLAN',
			coupon: null,
			appliedCoupon: null,
			discount_error: null,
			companyName: props.company.companyName,
			street: props.company.street,
			zip: props.company.zip,
			city: props.company.city,
			vatId: props.company.vatId,
			country: props.company.country,
			contactName: props.company.contactName,
			contactEmail: props.company.contactEmail,
			contactPhone: props.company.contactPhone,
			invoiceEmail: '',
			customSeatPrice: null,
			customVirtualSeatPrice: null,
			errorMessage: '',
		};
	}

	setValidTerm(billing, term) {
		if (billing === 'month' && ['Biannual', '2 Years', '3 Years'].includes(term)) {
			this.setState({
				term: 'Quarterly',
			});
		}
		if (billing === 'quarter' && term === 'Monthly') {
			this.setState({
				term: 'Quarterly',
			});
		}
		if (billing === 'annual' && ['Monthly', 'Quarterly', 'Biannual'].includes(term)) {
			this.setState({
				term: '1 Year',
			});
		}
	}

	selectBilling(val) {
		const coupon = this.state.appliedCoupon;
		if (coupon && coupon.duration === 'repeating' && coupon.percentOff !== null && coupon.durationInMonths % 12 !== 0) {
			this.setState({discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-not-annual'}), appliedCoupon: null});
		} else if (coupon && coupon.couponId.toUpperCase().endsWith('YEARLY')) {
			this.setState({discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-only-annual'}), appliedCoupon: null});
		}

		this.setValidTerm(val, this.state.term);

		this.setState({billing: val});
	}

	selectTerm(val) {
		this.setState({term: val});
	}

	selectPlan(val) {
		if (val === 'ENTERPRISE') {
			this.setState(
				{
					billing: 'annual',
				},
				() => {
					this.setValidTerm(this.state.billing, this.state.term);
				}
			);
		} else {
			this.setValidTerm(this.state.billing, this.state.term);
		}
		this.setState({selectedTier: val, perkListsExpanded: true});
	}

	selectCurrency(val) {
		this.setState({currency: val.value});
	}

	handleOnboardingCheck() {
		this.setState({
			isOnboarding: !this.state.isOnboarding,
		});
	}

	handleFieldChange(property, e) {
		this.setState({[property]: e.target ? e.target.value : e});
		if (property === 'zip') {
			this.setState({zip_error: false});
		}
	}

	validateSeats(users, seats, minimumSeats) {
		return seats >= minimumSeats && seats >= users;
	}

	validateVirtualSeats(virtualUsers, virtualSeats, minimumVirtualSeats) {
		return virtualSeats >= virtualUsers && virtualSeats >= minimumVirtualSeats;
	}

	processCouponValidation(result) {
		if (result.validateCoupon.found) {
			const coupon = result.validateCoupon;
			if (this.state.billing === 'annual') {
				if (coupon.duration === 'repeating' && coupon.percentOff !== null && coupon.durationInMonths % 12 !== 0) {
					this.setState({loading: false, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-not-annual'})});
					return;
				}
			} else {
				// Check that the coupon is not a yearly only coupon
				if (coupon.couponId.toUpperCase().endsWith('YEARLY')) {
					this.setState({loading: false, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-only-annual'})});
					return;
				}
			}
			this.setState({appliedCoupon: result.validateCoupon, loading: false, discount_error: null});
		} else {
			this.setState({loading: false, discount_error: this.props.intl.formatMessage({id: 'settings_subscription.coupon-not-valid'})});
		}
	}

	applyCoupon() {
		this.setState({loading: true});
		Util.CommitMutation(
			ValidateCouponMutation,
			{
				couponId: this.state.coupon || '',
			},
			this.processCouponValidation.bind(this)
		);
	}

	applySeatPriceChange() {
		this.setState({
			appliedSeatPriceChange: true,
			appliedManualSeatPrice: true,
			customSeatPrice: null,
		});
	}

	setDiscountCode(val) {
		this.setState({coupon: val, discount_error: null});
	}

	setCustomSeatPrice(val) {
		this.setState({customSeatPrice: val > 0 ? val : undefined});
	}

	setCustomVirtualSeatPrice(val) {
		this.setState({customVirtualSeatPrice: val > 0 ? val : undefined});
	}

	handleChangeCountry(selection) {
		const country = selection ? selection.value : null;
		this.setState({country});
		Util.CommitMutation(updateCompanyInternalDataMutation, {
			companyId: this.props.company.companyId,
			country,
		});
	}

	handleClientSave(property) {
		Util.CommitMutation(updateCompanyInternalDataMutation, {
			companyId: this.props.company.companyId,
			[property]: this.state[property],
		});
	}

	getPlansWithBillingCycle(billing, plans) {
		switch (billing) {
			case 'month':
				return plans.filter(plan => plan.periodUnit === 'MONTH' && plan.period === 1);
			case 'quarter':
				return plans.filter(plan => plan.periodUnit === 'MONTH' && plan.period === 3);
			case 'biannual':
				return plans.filter(plan => plan.periodUnit === 'MONTH' && plan.period === 6);
			case 'annual':
				return plans.filter(plan => plan.periodUnit === 'YEAR' && plan.period === 1);
		}
	}

	getCurrencies() {
		let availablePlans = this.props.plans.filter(plan => plan.chargebeeId.includes(this.state.selectedTier.toLowerCase()));
		let currencies = [];
		availablePlans = this.getPlansWithBillingCycle(this.state.billing, availablePlans);
		availablePlans.forEach(plan => {
			const currency = {
				label: plan.currency,
				value: plan.currency,
			};
			currencies.push(currency);
		});

		return currencies;
	}

	getSelectedPlan() {
		const {selectedTier, billing, currency} = this.state;

		const availablePlans = this.props.plans.filter(plan => plan.chargebeeId.includes(selectedTier.toLowerCase()) && plan.currency === currency);
		return this.getPlansWithBillingCycle(billing, availablePlans)[0];
	}

	getVirtualUser(selectedPlan) {
		const virtualUser = this.props.addons.filter(addon => addon.chargebeeId.includes('virtual_user') && addon.currency === selectedPlan.currency)[0];
		return virtualUser;
	}

	getOnboarding(selectedPlan) {
		return this.props.addons.filter(addon => addon.chargebeeId.includes('onboarding') && addon.currency === selectedPlan.currency && !addon.chargebeeId.includes('large'))[0];
	}

	onBack() {
		if (this.state.step === 'DETAILS') {
			this.setState({
				step: 'PLAN',
			});
		}
	}

	onContinue() {
		if (this.state.step === 'PLAN') {
			if (this.validateSeats(this.props.company.users, this.state.seats, this.props.company.minimumSeats) && this.validateVirtualSeats(this.props.company.virtualUsers, this.state.virtualSeats, this.props.company.minimumVirtualSeats)) {
				this.setState({
					step: 'DETAILS',
				});
			}
		} else {
			this.processSignup();
		}
	}

	processSignup() {
		const validTemp =
			this.state.companyName &&
			this.state.street &&
			this.state.zip &&
			this.state.city &&
			this.state.country &&
			this.state.contactEmail &&
			this.state.contactName &&
			this.state.contactPhone &&
			this.state.invoiceEmail !== '' &&
			this.state.invoiceEmail;
		const valid = validTemp !== null && validTemp !== '' ? validTemp : false;

		if (this.state.discount_error) {
			const field = document.getElementById('discount_code');
			field.focus();
			return;
		} else if (!valid) {
			this.focusMissingFields();
			return;
		}

		this.setState({loading: true});
		const selectedPlan = this.getSelectedPlan();
		const selectedVirtualUser = this.getVirtualUser(selectedPlan);
		const selectedOnboarding = this.getOnboarding(selectedPlan);
		const seatPriceTotal = this.state.customSeatPrice
			? selectedPlan.periodUnit === 'YEAR'
				? this.state.customSeatPrice * 12 * selectedPlan.period
				: selectedPlan.periodUnit === 'MONTH'
				? this.state.customSeatPrice * selectedPlan.period
				: null
			: null;

		Util.CommitMutation(
			TrialEndCreateCustomerInternalMutation,
			{
				companyId: this.props.company.companyId,
				invoiceEmail: this.state.invoiceEmail,
				contactPhone: this.state.contactPhone,
				coupon: this.state.appliedCoupon ? this.state.appliedCoupon.couponId : null,
				seats: +this.state.seats,
				virtualSeats: +this.state.virtualSeats,
				withOnboarding: this.state.isOnboarding,
				planId: selectedPlan.chargebeeId,
				virtualUserId: selectedVirtualUser.chargebeeId,
				onboardingId: selectedOnboarding.chargebeeId,
				term: this.state.term,
				changedSeatPrice: seatPriceTotal ? parseInt(seatPriceTotal * 100) : null,
				changedVirtualSeatPrice: this.state.customVirtualSeatPrice ? parseInt(this.state.customVirtualSeatPrice * 100) : null,
			},
			this.processUpgradeSuccess.bind(this)
		);
	}

	// Focus missing fields on existing page
	focusMissingFields(focusZip = false, focusVat = false) {
		if (this.state.step === 'DETAILS') {
			let field = null;
			if (!this.state.companyName) {
				field = document.getElementById('company_name');
			} else if (!this.state.street) {
				field = document.getElementById('company_street');
			} else if (!this.state.zip || focusZip) {
				field = document.getElementById('company_zip');
			} else if (!this.state.city) {
				field = document.getElementById('company_city');
			} else if (!this.state.country) {
				field = document.querySelector('company_country input');
			} else if ((this.state.country && EU_COUNTRIES_CODES.includes(this.state.country) && !this.state.vatId) || focusVat) {
				field = document.getElementById('company_vat');
			} else if (!this.state.contactName) {
				field = document.getElementById('company_contact_name');
			} else if (!this.state.contactEmail) {
				field = document.getElementById('company_contact_email');
			} else if (!this.state.contactPhone) {
				field = document.getElementById('company_contact_phone');
			} else if (!this.state.invoiceEmail || this.state.invoiceEmail === '') {
				field = document.getElementById('invoice_email');
			}
			if (field) {
				field.focus();
			}
		}
	}

	focusZip() {
		this.setState({step: 'DETAILS', zip_error: true}, () => {
			this.focusMissingFields(true);
		});
	}

	focusVat() {
		this.setState({step: 'DETAILS', vat_error: true}, () => {
			this.focusMissingFields(false, true);
		});
	}

	processUpgradeSuccess(result) {
		let error = null;
		if (result.trialEndCreateCustomerInternal && result.trialEndCreateCustomerInternal.errors) {
			error = result.trialEndCreateCustomerInternal.errors[0];
		}
		if (error != null) {
			this.setState({errorMessage: error});
		} else {
			this.setState({
				errorMessage: '',
				step: 'COMPLETE',
			});
		}
		this.setState({loading: false});
	}

	render() {
		const {companyName, jiraEnabled, minimumSeats, minimumVirtualSeats, users, virtualUsers, trialEndDay, trialEndMonth, trialEndYear} = this.props.company;
		const {
			billing,
			term,
			selectedTier,
			currency,
			isOnboarding,
			seats,
			virtualSeats,
			street,
			zip,
			zip_error,
			vat_error,
			city,
			vatId,
			country,
			contactName,
			contactEmail,
			contactPhone,
			invoiceEmail,
			step,
			appliedManualSeatPrice,
			appliedSeatPriceChange,
			errorMessage,
			loading,
		} = this.state;

		const selectedPlan = this.getSelectedPlan();
		const virtualUser = this.getVirtualUser(selectedPlan);
		const onboarding = this.getOnboarding(selectedPlan);

		const currencies = this.getCurrencies();
		const currencySymbol = Util.GetCurrencySymbol(currency);
		const dueDate = Util.CreateMomentDate(trialEndYear, trialEndMonth, trialEndDay);
		const headerText = `Sign up for ${companyName}`;

		const content = (
			<SignUpModalStyle>
				{step === 'PLAN' ? (
					<PlanSection
						jiraEnabled={jiraEnabled}
						minimumSeats={minimumSeats}
						minimumVirtualSeats={minimumVirtualSeats}
						users={users}
						virtualUsers={virtualUsers}
						currencies={currencies}
						billing={billing}
						currency={currency}
						seats={seats}
						virtualSeats={virtualSeats}
						isOnboarding={isOnboarding}
						term={term}
						selectedTier={selectedTier}
						plans={this.props.plans}
						onboarding={onboarding}
						currencySymbol={currencySymbol}
						selectBilling={this.selectBilling.bind(this)}
						selectTerm={this.selectTerm.bind(this)}
						selectPlan={this.selectPlan.bind(this)}
						selectCurrency={this.selectCurrency.bind(this)}
						handleOnboardingCheck={this.handleOnboardingCheck.bind(this)}
						handleFieldChange={this.handleFieldChange.bind(this)}
						validateSeats={this.validateSeats.bind(this)}
						validateVirtualSeats={this.validateVirtualSeats.bind(this)}
						getPlansWithBillingCycle={this.getPlansWithBillingCycle.bind(this)}
					/>
				) : null}
				{step === 'DETAILS' ? (
					<DetailsSection
						minimumSeats={minimumSeats}
						selectedTier={selectedTier}
						users={users}
						virtualUsers={virtualUsers}
						name={companyName}
						street={street}
						zip={zip}
						zip_error={zip_error}
						vat_error={vat_error}
						city={city}
						vatId={vatId}
						country={country}
						contactName={contactName}
						contactEmail={contactEmail}
						contactPhone={contactPhone}
						seats={seats}
						virtualSeats={virtualSeats}
						handleFieldChange={this.handleFieldChange.bind(this)}
						handleChangeCountry={this.handleChangeCountry.bind(this)}
						handleClientSave={this.handleClientSave.bind(this)}
						validateSeats={this.validateSeats.bind(this)}
						validateVirtualSeats={this.validateVirtualSeats.bind(this)}
						invoiceEmail={invoiceEmail}
					/>
				) : null}
				<div className="right-side">
					<Receipt
						dueDate={dueDate}
						users={users}
						virtualUsers={virtualUsers}
						seats={this.state.seats}
						virtualSeats={this.state.virtualSeats}
						billing={this.state.billing}
						setBilling={this.selectBilling.bind(this)}
						isOnboarding={isOnboarding}
						onboarding={onboarding}
						appliedCoupon={this.state.appliedCoupon}
						discount_error={this.state.discount_error}
						applyCoupon={this.applyCoupon.bind(this)}
						applySeatPriceChange={this.applySeatPriceChange.bind(this)}
						customSeatPrice={this.state.customSeatPrice}
						customVirtualSeatPrice={this.state.customVirtualSeatPrice}
						setDiscountCode={this.setDiscountCode.bind(this)}
						setCustomSeatPrice={this.setCustomSeatPrice.bind(this)}
						setCustomVirtualSeatPrice={this.setCustomVirtualSeatPrice.bind(this)}
						validateSeats={this.validateSeats.bind(this)}
						validateVirtualSeats={this.validateVirtualSeats.bind(this)}
						selectedTier={this.state.selectedTier}
						isPaid={this.state.step === 'COMPLETE'}
						country={country}
						plans={this.props.plans}
						virtualUser={virtualUser}
						selectedPlan={selectedPlan}
						currencySymbol={currencySymbol}
						step={step}
						appliedManualSeatPrice={appliedManualSeatPrice}
						appliedSeatPriceChange={appliedSeatPriceChange}
						hideMonthly={step === 'COMPLETE'}
						currency={currency}
					/>
					<SignUpError>{errorMessage}</SignUpError>
				</div>
			</SignUpModalStyle>
		);

		const buttons = [
			{
				text: this.state.step === 'DETAILS' ? 'Back' : 'COMPLETE' ? 'Close' : 'Cancel',
				style: BUTTON_STYLE.FILLED,
				color: BUTTON_COLOR.WHITE,
				callback: this.onBack.bind(this),
				preventDefaultClose: this.state.step === 'DETAILS',
			},
		];
		if (step !== 'COMPLETE') {
			buttons.push({
				text: this.state.step === 'DETAILS' ? 'Save' : 'Continue',
				style: BUTTON_STYLE.FILLED,
				color: BUTTON_COLOR.GREEN,
				callback: this.onContinue.bind(this),
				preventDefaultClose: true,
				disabled: loading,
			});
		}

		return <GenericModal closeModal={this.props.closeModal} buttons={buttons} content={content} headerText={headerText} />;
	}
}

export default injectIntl(SignUpModal, {forwardRef: true});
